angular.module('user')
    .controller('LogoutButtonController', ['Modal', 'AccountManager', 'LogoutManager', function(Modal, AccountManager, LogoutManager) {
        var vm = this;

        vm.logout = function() {
            return Modal
                .open({
                    template: 'js/modules/user/components/logout-button/modal.html',
                    controller: 'LogoutModalController',
                    controllerAs: 'modal',
                    showClose: false,
                    closeByNavigation: true,
                })
                .closePromise
                .then(function() {
                    // Confirm button pressed
                    return AccountManager.logout()
                        .then(function() {
                            return LogoutManager.onLogout();
                        });
                })
                .catch(function() {
                    // Cancel button pressed
                    // This block is only to avoid Angular notice: 'Possibly unhandled rejection: $rejected'
                });
        };
    }]);
